import { useTranslation } from 'react-i18next';
import { Affix, Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import DataFlowService from '../../../../services/DataFlow.service';
import { ROUTER } from '../../../../constants/router';
import moment from 'moment';
import { STATUS_ID as STATUS } from '../../STATUS_ID';

const Tab4 = ({ collectDataDestruction, editMode, isNoPermission, dataFlowInfo }) => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const { businessProcessId } = useParams();
    const [storageLocation, setStorageLocation] = useState([]);

    useEffect(() => {
        getMasterStorageLocation();
    }, []);

    const getMasterStorageLocation = async () => {
        try {
            const { data } = await DataFlowService.getMasterStorageLocation();
            if (data?.resultData) {
                setStorageLocation(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const getMasterStorageLocationName = (id) => {
        if (id && storageLocation?.length > 0) {
            const result = storageLocation.filter(
                (data) => data.statusId === id
            );
            if (result?.length > 0) {
                return (
                    <p className="mb-0">
                        &#8226;{' '}
                        {i18n.language === 'en'
                            ? result[0].nameEn
                            : result[0].nameTh}
                    </p>
                );
            } else {
                return <p className="mb-0">&#8226; {id}</p>;
            }
        }
    };

    const getNotificationTypeString = (type) => {
        const notificationTypeMap = {
            99: t('dataFlow.none'),
            0: t('dataFlow.on_day_of_event'),
            1: t('dataFlow.1_day_before'),
            2: t('dataFlow.2_day_before'),
            7: t('dataFlow.1_week_before'),
        };

        return notificationTypeMap[type] || '-';
    };

    return (
        <div className="grid grid-cols-3">
            <div className="col-span-3 text-right mt-2 mb-2">
                <Affix offsetTop={60}>
                    <Button
                        hidden={!editMode || (isNoPermission && dataFlowInfo.statusId !== STATUS.REVISE)}
                        type="primary"
                        style={{ padding: '0px 30px' }}
                        onClick={() => {
                            navigate(
                                `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}?tab=4`
                            );
                        }}
                        size="large"
                        ghost
                    >
                        {t('common.Edit')}
                    </Button>
                </Affix>
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.storageLocation')}
                </div>

                {collectDataDestruction?.storageLocation.length > 0 &&
                    collectDataDestruction?.storageLocation.map((item) =>
                        getMasterStorageLocationName(item)
                    )}
                {collectDataDestruction?.storageLocationAddOn.map((item) => (
                    <p className="mb-0">
                        &#8226; {item.tstorageLocationAddOnName}
                    </p>
                ))}
                {!collectDataDestruction?.storageLocation &&
                    !collectDataDestruction?.storageLocationAddOn &&
                    '-'}
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.processRequestingDataApproval')}
                </div>
                <p className="mb-0 whitespace-pre-wrap">
                    {collectDataDestruction?.processRequestingDataApproval
                        ? collectDataDestruction.processRequestingDataApproval
                        : '-'}
                </p>
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.preventControlDataDetails')}
                </div>
                {collectDataDestruction?.preventControlDataDetail.length > 0
                    ? collectDataDestruction?.preventControlDataDetail.map(
                        (item) => (
                            <p className="mb-0">
                                &#8226; {item.preventControlDataDetail}
                            </p>
                        )
                    )
                    : '-'}
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.stepTodeleteDestructionData')}
                </div>
                <p className="mb-0 whitespace-pre-wrap">
                    {collectDataDestruction?.stepToDeleteDestructionData
                        ? collectDataDestruction.stepToDeleteDestructionData
                        : '-'}
                </p>
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.ownerAcessDelete')}
                </div>
                {collectDataDestruction?.ownerAccessDelete.length > 0
                    ? collectDataDestruction?.ownerAccessDelete.map((item) => (
                        <p className="mb-0">
                            &#8226; {item.ownerAccessDeleteDetail}
                        </p>
                    ))
                    : '-'}
            </div>
            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.notificationforToDestroy')}
                </div>
                <p className='font-semibold	text-sm'>{t('dataFlow.TheDateYouWantToDeleteOrDestroyTheData')}</p>
                <p>{collectDataDestruction?.destructionDate ? moment(collectDataDestruction?.destructionDate).format('DD/MM/YYYY') : '-'}</p>
                <p className='font-semibold	text-sm'>{t('dataFlow.notification')}</p>
                <p>{getNotificationTypeString(collectDataDestruction?.notificationType)}</p>
                <p className='font-semibold	text-sm'>{t('dataFlow.who_gets_email_notifications')}</p>
                <p>{collectDataDestruction?.receiverName}</p>
            </div>
        </div>
    );
};

export default Tab4;
